import React from 'react'
import '../../styles/5-Portfolio/Portfolio.css'

const Project = ({ data }) => {
  return (
    <article id='project'>
      <div className='project__img'>
        <img src={data.src} alt={data.name}/>
      </div>
      <a className='project__link' target='_blank' href={data.repositoryURL}>
        <button>Repo</button>
      </a>
      <a className='project__link' target='_blank' href={data.demoURL}>
        <button>Demo</button>
      </a>
    </article>
  )
}

export default Project